import React, { Component } from 'react';
import $ from 'jquery'

class BezpecnostSiti extends Component {
    componentDidMount(){


        function resetMenu(){
            $("#home a").removeClass("active");

            $("#sluzby-a-produkty-link").removeClass("active");
            $("#prodej-instalace-li").removeClass("active");
            $("#lokalni-li").removeClass("active");
            $("#outsourcing-li").removeClass("active");
            $("#audit-is-li").removeClass("active");
            $("#webhosting-li").removeClass("active");
            $("#webdesign-li").removeClass("active");
            $("#cenik-praci-li").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();

        $("#basic-nav-dropdown").addClass("active");


    }
  render() {
    return (
<div>


        <div className="container content fade-in two" id="bezpecnost-siti">
            <h1> Bezpečnost sítí</h1>

<span>
            <h2>Firewall</h2>
            Mezi základní komponenty pro zajištění počítačové sítě proti útokům zvenčí (z Internetu) patří bezpečnostní brány (firewally). Je možné použít jak softwarové řešení nainstalované na vhodném počítači, tak i komplexní specializované řešení, jako je řada Symantec Gateway Security 5600 zahrnující v sobě volitelně i antivirovou ochranu, detekci narušení a filtrování obsahu. Pro menší firmy můžeme nabídnout zařízení Symantec 1600 nebo 400, případně i dalších výrobců. Pro sítě vybavené servery Linux pak lze použít softwarové řešení.
<br/><br/>
            <h2>Antivirová ochrana</h2>
            Další důležitou a dnes již v podstatě běžnou komponentou počítačových sítí je antivirová ochrana. Zde doporučujeme vícestupňovou ochranu založenou na produktu Symantec Client Security, která zahrnuje poštovní servery, souborové servery a klientské počítače, u kterých je součástí i firewallová komponenta. Důležitou částí produktu je centrální konfigurace antivirových klientů včetně automatické distribuce virových definic. Nově je v tomto produktu zahrnuta i ochrana proti škodlivému software (trojské koně, spyware, adware). Podle volby zákazníka můžeme podporovat i řešení jiných výrobců.
<br/><br/>
                <h2>Blokování nevyžádané pošty</h2>
            V posledních letech se stává stále větším problémem nevyžádaná pošta (spam), jejíž objem dosahuje až 70% všech zpráv elektronické pošty. Kromě obtěžování uživatelů začíná navíc být spojena i s bezpečnostními riziky plynoucími z vložených odkazů a s technickými problémy vyplývajícími z velkého zatížení serverů. V současné době představuje špičku v řešení tohoto problému produkt Brightmail AntiSpam firmy Symantec. Jeho hlavní předností je vysoká přesnost detekce, při které je zachyceno více než 95% nevyžádané pošty, a přitom se prakticky nevyskytují případy, kdy by byla jako spam označena legální zpráva. Instalaci tohoto produktu může zajistit v několika konfiguracích podle potřeb uživatele, topologie a zatížení sítě. Zájemcům nabízíme navíc možnost odzkoušení produktu přímo v ostrém provozu jejich počítačové sítě.
<br/><br/>
                    <h2>IDS</h2>
            Sebelepší firewall a antivirová ochrana však nemůže ochránit počítačovou síť proti všem nebezpečím. Kromě útoků, které přicházejí přes neošetřené zranitelnosti legálních aplikací např. v podobě automaticky se šířících červů, se jedné i o různý spyware a o útoky vedené z vnitřní sítě. Nebezpečí představují i přenosné počítače, s kterými se uživatelé připojují k Internetu i mimo chráněné prostředí počítačové sítě. Ke kontrole provozu proto doporučujeme systémy pro detekci narušení. Základní detekce pro počítače koncových uživatelů je již obsažena v produktu Symantec Client Security (viz antivirová ochrana). Pro detekci na serverech je možné volit programový produkt Host IDS, pro sledování a vyhodnocování provozu v kterémkoliv místě počítačové sítě pak nabízíme Symantec Network Security buď jako programový produkt nebo jako speciální předinstalované zařízení. Naši specialisté mohou pomoci i s vyhodnocením významu jednotlivých detekovaných událostí.
<br/><br/>
                        <h2>Vzdálený přístup, VPN, Certifikáty</h2>
            Pro mnoho uživatelů je důležitá možnost bezpečného přístupu k podnikovým informacím včetně zpráv elektronické pošty i na cestách mimo firmu. Proto zajišťujeme různé varianty připojení – počínaje přístupem k elektronické poště přes webovské rozhraní až po VPN připojení zabezpečené klientskými certifikáty. V případě, kdy pro podobné řešení není u zákazníka vhodná infrastruktura, zajistíme instalaci i jiného řešení, jako např. Eurotel Office Connector.
</span>
        </div>


</div>
    );
  }
}

export default BezpecnostSiti;



// WEBPACK FOOTER //
// ./src/sluzby-a-produkty/BezpecnostSiti.js